<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import axios from 'axios';
import { useAuthStore } from '@stores';

const apiUrl = import.meta.env.VITE_API_URL;
const authStore = useAuthStore();
const { t } = useI18n({ useScope: 'global' });
const emits = defineEmits(['update:isVisible', 'save']);
const props = defineProps({
    apikeyId: {
        type: String,
    },
});

const editData = ref({});

const resolver = ({ values }) => {
    const errors = {};

    if (!values.keyname) {
        errors.keyname = [{ message: t('apikey.keyRequired') }];
    }
    return {
        errors,
    };
};
const saveChanges = async () => {
    if (!editData.value.name) {
        return;
    }
    try {
        await axios.post(
            `${apiUrl}/v1/key`,
            {
                name: editData.value.name,
                id: editData.value.id,
                is_active: editData.value.is_active,
            },
            {
                headers: {
                    Authorization: `Bearer ${authStore.userToken}`,
                    'Content-Type': 'application/json',
                },
            }
        );
        emits('save', editData.value);
        closeDialog();
    } catch (error) {
        console.error(error);
    }
};

const getEditData = async (id) => {
    try {
        const data = await axios.get(`${apiUrl}/v1/key`, {
            params: {
                id,
            },
            headers: {
                Authorization: `Bearer ${authStore.userToken}`,
                'Content-Type': 'application/json',
            },
        });

        editData.value = data.data.data;
    } catch (error) {
        console.error(error);
    }
};

const closeDialog = () => {
    emits('update:isVisible', false);
};

watch(
    () => props.apikeyId,
    (id) => {
        getEditData(id);
    },
    { immediate: true }
);
</script>

<template>
    <Dialog modal dismissableMask :header="t('apikey.editKey')">
        <Form v-slot="$form" :resolver="resolver" @submit="saveChanges" class="edit-container">
            <label for="keyname" class="font-semibold">{{ t('apikey.keyName') }}</label>
            <InputText name="keyname" id="keyname" v-model.trim="editData.name" autocomplete="off" />
            <Message v-if="$form.keyname?.invalid" severity="error" size="small" variant="simple">{{ $form.keyname.error?.message }}</Message>

            <div class="edit-buttons">
                <Button @click="closeDialog" type="button" :label="t('form.cancel')" severity="secondary"></Button>
                <Button type="submit" :label="t('global.save')" severity="info"></Button>
            </div>
        </Form>
    </Dialog>
</template>

<style scoped>
.edit-container {
    @apply flex flex-col gap-1 w-[400px];
}

.edit-buttons {
    @apply flex justify-end gap-2 mt-4;
}
</style>
